import { prefixerI } from './common'

export const ROUTE_INFORMES_LISTADO_ORDEN_TRABAJO = prefixerI('listadoOrdenesTrabajos')
